import {EntityViewProperties} from "./EntityViewProperties";

export const RequestFeatureInfoAdmin = `
    query requestFeatureInfoAdmin  ($fullUid: String!) {
        allEntitiesviewAdmins (condition: {fullUid: $fullUid}) {
            nodes {
                stAsgeojson
                ${EntityViewProperties}
            }
        }
    }
`;
